"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */

var pick = exports.pick = function pick(obj, keys) {
  var r = {};
  keys.forEach(function (key) {
    r[key] = obj[key];
  });
  return r;
};


//////////////////
// WEBPACK FOOTER
// ./~/echarts-for-react/lib/utils.js
// module id = 7969
// module chunks = 2